import React, { useRef, useContext, useState } from 'react'
import { Settings, X } from 'react-feather'
import styled from 'styled-components'
import { useOnClickOutside } from '../../hooks/useOnClickOutside'
import {
  useUserSlippageTolerance,
  useExpertModeManager,
  useUserDeadline,
  useDarkModeManager,
  useLangModeManager
} from '../../state/user/hooks'
import TransactionSettings from '../TransactionSettings'
import { RowFixed, RowBetween } from '../Row'
import { TYPE } from '../../theme'
import QuestionHelper from '../QuestionHelper'
import Toggle from '../Toggle'
import { ThemeContext } from 'styled-components'
import { AutoColumn } from '../Column'
import { ButtonError } from '../Button'
import { useSettingsMenuOpen, useToggleSettingsMenu } from '../../state/application/hooks'
import { Text } from 'rebass'
import Modal from '../Modal'
import { useTranslation } from 'react-i18next'
import Logo from '../../assets/png/setting.png'

const StyledMenuIcon = styled(Settings)`
  height: 20px;
  width: 20px;

  > * {
    stroke: ${({ theme }) => theme.text1};
  }
`

const StyledCloseIcon = styled(X)`
  height: 20px;
  width: 20px;
  :hover {
    cursor: pointer;
  }

  > * {
    stroke: ${({ theme }) => theme.text1};
  }
`

const StyledMenuButton = styled.button`
  position: relative;
  width: 100%;
  height: 100%;
  border: none;
  background-color: transparent;
  margin-right: 1rem;
  padding: 0;
  height: 35px;
  // background-color: ${({ theme }) => theme.bg3}; // ${({ theme }) => theme.bg3} #f8783a2e #313236

  // padding: 0.15rem 0.15rem;
  border-radius: 0.5rem;
  background-color: #131414f0;
  border: 2px solid;
   border-image: linear-gradient(135deg, #747474, #090909 50%, #747474) 2;
   clip-path: inset(0 round 100%);

  :hover,
  :focus {
    cursor: pointer;
    outline: none;
    background-color: ${({ theme }) => theme.bg4};
  }

  svg {
    margin-top: 2px;
  }
`
const EmojiWrapper = styled.div`
  position: absolute;
  bottom: -6px;
  right: 0px;
  font-size: 14px;
`

const StyledMenu = styled.div`
  // margin-left: 0.5rem; // zyl
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  border: none;
  text-align: left;
`

const MenuFlyout = styled.span`
  min-width: 20.125rem;
  background-color: ${({ theme }) => theme.bg1};
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.01), 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 16px 24px rgba(0, 0, 0, 0.04),
    0px 24px 32px rgba(0, 0, 0, 0.01);

  border: 1px solid ${({ theme }) => theme.bg3};

  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;
  font-size: 1rem;
  position: absolute;
  top: 3rem;
  right: 0rem;
  z-index: 100;

  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    min-width: 18.125rem;
	top: 3.5rem; // zyl add
    right: 1.5rem; // zyl right: -46px;
  `};
`

const Break = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.bg3};
`

const ModalContentWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 0;
  background-color: ${({ theme }) => theme.bg2};
  border-radius: 20px;
`

const FancyButton = styled.button`
  color: ${({ theme }) => theme.text1};
  align-items: center;
  height: 2rem;
  border-radius: 36px;
  font-size: 12px;
  width: auto;
  min-width: 3rem;
  border: 1px solid ${({ theme }) => theme.bg3};
  outline: none;
  background: ${({ theme }) => theme.bg1};
  :hover {
    border: 1px solid ${({ theme }) => theme.bg4};
  }
  :focus {
    border: 1px solid ${({ theme }) => theme.primary1};
  }
`

const Option = styled(FancyButton)<{ active: boolean }>`
  margin-right: 4px;
  margin-left: 4px;
  :hover {
    cursor: pointer;
  }
  background-color: ${({ active, theme }) => active && theme.primary1};
  color: ${({ active, theme }) => (active ? theme.white : theme.text1)};
`

export default function SettingsTab() {
  const { t } = useTranslation()
  const node = useRef<HTMLDivElement>()
  const open = useSettingsMenuOpen()
  const toggle = useToggleSettingsMenu()

  const theme = useContext(ThemeContext)
  const [userSlippageTolerance, setUserslippageTolerance] = useUserSlippageTolerance()

  const [deadline, setDeadline] = useUserDeadline()

  const [expertMode, toggleExpertMode] = useExpertModeManager()

  const [darkMode, toggleDarkMode] = useDarkModeManager()
  
  const [langMode, toggleLangMode] = useLangModeManager()

  // show confirmation view before turning on
  const [showConfirmation, setShowConfirmation] = useState(false)

  useOnClickOutside(node, open ? toggle : undefined)
  
  let isCross = false;
  if (window.location.href.indexOf("cross.") >= 0) {
  	  isCross = true;
  }
  
  return (
    // https://github.com/DefinitelyTyped/DefinitelyTyped/issues/30451
    <StyledMenu ref={node as any}>
      <Modal isOpen={showConfirmation} onDismiss={() => setShowConfirmation(false)} maxHeight={100}>
        <ModalContentWrapper>
          <AutoColumn gap="lg">
            <RowBetween style={{ padding: '0 2rem' }}>
              <div />
              <Text fontWeight={500} fontSize={20}>
                {t('zylConfirmExpert1')}
              </Text>
              <StyledCloseIcon onClick={() => setShowConfirmation(false)} />
            </RowBetween>
            <Break />
            <AutoColumn gap="lg" style={{ padding: '0 2rem' }}>
              <Text fontWeight={500} fontSize={20}>
                {t('zylConfirmExpert2')}
              </Text>
              <Text fontWeight={600} fontSize={20}>
                {t('zylConfirmExpert3')}
              </Text>
              <ButtonError
                error={true}
                padding={'12px'}
                onClick={() => {
                  // if (window.prompt(t('zylConfirmExpert5')) === 'confirm') {
                    toggleExpertMode()
                    setShowConfirmation(false)
                  // }
                }}
              >
                <Text fontSize={20} fontWeight={500} id="confirm-expert-mode">
                  {t('zylConfirmExpert4')}
                </Text>
              </ButtonError>
            </AutoColumn>
          </AutoColumn>
        </ModalContentWrapper>
      </Modal>
      {!isCross && (<StyledMenuButton onClick={toggle} id="open-settings-dialog-button">
        {false && (<StyledMenuIcon />)}
		<img style={{ maxHeight: '2rem', maxWidth: '2rem' }} src={Logo} alt="logo" />
        {expertMode && (
          <EmojiWrapper>
            <span role="img" aria-label="wizard-icon">
              ??
            </span>
          </EmojiWrapper>
        )}
      </StyledMenuButton>)}
      {open && (
        <MenuFlyout>
          <AutoColumn gap="md" style={{ padding: '1rem' }}>
            <Text fontWeight={600} fontSize={14}>
              {t('zylSetting1')}
            </Text>
            <TransactionSettings
              rawSlippage={userSlippageTolerance}
              setRawSlippage={setUserslippageTolerance}
              deadline={deadline}
              setDeadline={setDeadline}
            />
            <Text fontWeight={600} fontSize={14}>
              {t('zylSetting2')}
            </Text>
            <RowBetween>
              <RowFixed>
                <TYPE.black fontWeight={400} fontSize={14} color={theme.text2}>
                  {t('zylModeExpert')}
                </TYPE.black>
                <QuestionHelper text={t('zylDescExpert')} />
              </RowFixed>
              <Toggle
                id="toggle-expert-mode-button"
                isActive={expertMode}
                toggle={
                  expertMode
                    ? () => {
                        toggleExpertMode()
                        setShowConfirmation(false)
                      }
                    : () => {
                        toggle()
                        setShowConfirmation(true)
                      }
                }
              />
            </RowBetween>
            <RowBetween>
              <RowFixed>
                <TYPE.black fontWeight={400} fontSize={14} color={theme.text2}>
                  {t('zylModeDark')}
                </TYPE.black>
              </RowFixed>
              <Toggle isActive={darkMode} toggle={toggleDarkMode} />
            </RowBetween>
			<RowBetween>
			  <RowFixed>
			    <TYPE.black fontWeight={400} fontSize={14} color={theme.text2}>
			      {t('zylModeLang')}
			    </TYPE.black>
			  </RowFixed>
			  <Option
			    onClick={() => {
			      window.localStorage.setItem('i18nextLng', 'en');
				  window.location.reload();
			    }}
			    active={window.localStorage.getItem('i18nextLng') === 'en'}
			  >
			    {t('zylEn')}
			  </Option>
			  <Option
			    onClick={() => {
			      window.localStorage.setItem('i18nextLng', 'zh-CN');
				  window.location.reload();
			    }}
			    active={window.localStorage.getItem('i18nextLng') === 'zh-CN'}
			  >
			    {t('zylZh')}
			  </Option>
			  <Option
			    onClick={() => {
			     window.localStorage.setItem('i18nextLng', 'zh-TW');
				 window.location.reload();
			    }}
			    active={window.localStorage.getItem('i18nextLng') === 'zh-TW'}
			  >
			    {t('zylZhTw')}
			  </Option>
			  {false && (<Toggle isActive={langMode} toggle={toggleLangMode} textOn={t('zylEn')} textOff={t('zylZh')} />)}
			</RowBetween>
          </AutoColumn>
        </MenuFlyout>
      )}
    </StyledMenu>
  )
}
